import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FlexBox, FlexItem, Space } from '@codex-brightworld/basics';
import { AddToBasketButton } from '@codex-brightworld/organisms';

export const FooterWrapperWithSpace = styled(Space)`
`;

const FlexItemDesktop = styled(FlexItem)`
  display: block;
  @media ${props => props.theme.breakpoints.tablet} {
    display: none;
  }
`;

const FlexItemMobile = styled(FlexItem)`
  display: none;
  @media ${props => props.theme.breakpoints.tablet} {
    display: block;
  }
`;

export const TotalSavings = styled(Space)`
  flex-grow: 1;
  color: ${props => props.theme.colors.primary.magenta};
  text-align: center;
  font-size: 16px;
`;

export const TotalPrice = styled(Space)`
  text-align: center;
  font-size: 16px;
`;

export const PriceDescription = styled.div`
  color: ${props => props.theme.colors.shades[3]};
  font-size: 14px;
  text-align: center;
`;

export const ButtonWrapper = styled(Space)`
  text-align: right;
  
  @media ${props => props.theme.breakpoints.mobile} {
    text-align: center;
  }
`;

export const StyledButton = styled(AddToBasketButton)`
  max-width: 228px;
`;

const BundleFooter = props => (
  <FooterWrapperWithSpace all={{ default: '0 24 26 24', mobile: '0 16 21 16' }}>
    <FlexBox
      alignItems={{ mobile: 'stretch', default: 'center' }}
      direction={{ mobile: 'column', default: 'row' }}
      justifyContent={{ mobile: 'normal', default: !props.totalSaving ? 'flex-end' : '' }}
      wrap="wrap"
    >
      <FlexItemDesktop
        basis={{
          mobile: '100%',
          tablet: '50%',
          desktopSmall: '33%',
          desktopWide: '33%'
        }}
        order={{
          desktopWide: -1
        }}
      >
        <Space top={{ touch: 10, desktopSmall: 10 }} right={{ desktopWide: 10 }}>
          {props.totalSaving && (
            <PriceDescription>
              {props.priceDescription}
            </PriceDescription>
          )}
        </Space>
      </FlexItemDesktop>

      <FlexItem
        basis={{
          mobile: '100%',
          tablet: '50%',
          desktopSmall: '34%',
          desktopWide: '34%'
        }}
      >
        <FlexBox alignItems="stretch" justifyContent="flex-end">
          {props.totalSaving && (
            <TotalSavings
              all={{
                mobile: '10 5',
                tablet: '10 8',
                desktopSmall: '10 8',
                desktopWide: '10 8'
              }}
              property="margin"
            >
              {props.totalSaving}
            </TotalSavings>
          )}

          <FlexItem grow={{ mobile: 1, default: props.totalSaving ? 1 : 0 }} shrink={1}>
            <TotalPrice
              all={{
                mobile: '10 5',
                tablet: '10 8',
                desktopSmall: '10 8',
                desktopWide: '10 8'
              }}
              property="margin"
              withSaving={props.totalSaving}
            >
              {props.totalPrice}
            </TotalPrice>
          </FlexItem>

        </FlexBox>
      </FlexItem>

      <FlexItem
        basis={{
          mobile: '100%',
          tablet: props.totalSaving ? '50%' : '45%',
          desktopSmall: '33%',
          desktopWide: '33%'
        }}
      >
        <ButtonWrapper top={{ mobile: 10 }}>
          {props.children
            ? props.children
            : (
              <StyledButton
                productId={props.bundleId}
                postUrl={window.location.href}
                placement={AddToBasketButton.placements.BUNDLE}
                onFormSubmit={callback => props.onAddToBasket(
                  [props.productId, ...props.addonsIds],
                  props.bundleType,
                  callback
                )}
                renderAdditionalHiddenInputs={() => {
                  const visitorId = window.adobeVisID || 0;
                  const inputs = [
                    <input type="hidden" name="visitorId" value={visitorId} key={visitorId} />
                  ];

                  props.addonsIds.forEach(id => inputs.push(
                    <input type="hidden" name="addonProductsIds[]" value={id} key={id} />
                  ));

                  return inputs;
                }}
              >
                {props.addButtonLabel}
              </StyledButton>
            )}
        </ButtonWrapper>
      </FlexItem>

      <FlexItemMobile
        basis={{
          mobile: '100%',
          tablet: '50%',
          desktopSmall: '33%',
          desktopWide: '33%'
        }}
        order={{
          desktopWide: -1
        }}
      >
        <Space top={{ touch: 10, desktopSmall: 10 }} right={{ desktopWide: 10 }}>
          {props.totalSaving && (
            <PriceDescription>
              {props.priceDescription}
            </PriceDescription>
          )}
        </Space>
      </FlexItemMobile>

    </FlexBox>
  </FooterWrapperWithSpace>
);

BundleFooter.propTypes = {
  addonsIds: PropTypes.arrayOf(PropTypes.string),
  addButtonLabel: PropTypes.string,
  bundleId: PropTypes.string,
  bundleType: PropTypes.string,
  children: PropTypes.element,
  onAddToBasket: PropTypes.func,
  priceDescription: PropTypes.string,
  productId: PropTypes.string,
  totalPrice: PropTypes.string,
  totalSaving: PropTypes.string
};

BundleFooter.defaultProps = {
  addonsIds: [],
  addButtonLabel: '',
  bundleId: '',
  bundleType: '',
  children: undefined,
  onAddToBasket: () => {},
  priceDescription: '',
  productId: '',
  totalPrice: '',
  totalSaving: ''
};

export default BundleFooter;
